<i18n lang='yml' src='../i18n/SubmitQuestions.yml'></i18n>
<template>
   <div>
      <input type="hidden" name="survey_responses[user_id]" value="user_id" />
      <div class="form-group">
         <div v-if="errors.length">
            <strong> {{ $t('errors') }}</strong>
            <ul>
               <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
         </div>
      </div>
      <div v-for="(question) in questions" :key="question.id">
         <input type="hidden" :name="'survey_responses[responses][' + question.id + '][id]'" :value="responses[question.id].id"/>
         <input type="hidden" :name="'survey_responses[responses][' + question.id + '][container_metadata_question_id]'" :value="question.id" />
         <input type="hidden" :name="'survey_responses[responses][' + question.id + '][response_text]'" :value="responses[question.id].response_text" />
         <input type="hidden" :name="'survey_responses[responses][' + question.id + '][validation_type]'" :value="question.validation_type" />
         <div class="row">
            <div class="col-sm-12 col-md-8 metadata_questions" >
               <div class="form-group">
                  <template v-if="questionIsSelectOne(question)">      
                     <fieldset>
                      <Field 
                        :name="`${locale == 'en' ? question.title : question.additional_language_text[locale]}`" 
                        :rules="question.required ? 'required' : null"
                        v-slot="{ errors, field }"
                        v-model="responses[question.id].survey_answer_id"> 
                        <label :for="`survey_responses[responses][${question.id}][survey_answer_id]`">
                          <span>
                            {{ locale == "en" ? question.title : question.additional_language_text[locale]}}
                          </span>
                              
                          <span v-if="question.required" class='red'>*<span class="sr-only">{{$t('required')}}</span></span>
                        </label>
                        <div class="radio" :class="{'is-invalid': errors[0]}" v-for="answer in question.answers" :key="answer.id">
                          <label class="form-check-label">
                            <input 
                              type="radio" 
                              :id="`survey_responses[responses][${question.id}][survey_answer_id]`"
                              :name="`survey_responses[responses][${question.id}][survey_answer_id]`"
                              :aria-checked="`${$t('inter_provincial_exam')}_true`" 
                              :value="answer.id"
                              v-bind="field">
                            {{ answer.answer_text }}
                          </label>
                        </div>
                        <div class="invalid-feedback" :id="`survey_responses[responses][${question.id}][survey_answer_id]_error`" v-if="errors[0]">
                          <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                          <span>{{ errors[0] }}</span> 
                        </div>
                      </Field>        
                    </fieldset>
                  </template>
                  <template v-else-if="questionIsSelectMultiple(question)">
                    <Field 
                      :name="`${locale == 'en' ? question.title : question.additional_language_text[locale]}`" 
                      :rules="question.required ? 'required' : null"
                      v-slot="{ errors, field }"
                      v-model="responses[question.id].survey_answer_id">
                      <label :for="`survey_responses[responses][${question.id}][survey_answer_id]`">
                        <span >{{ locale == "en" ? question.title : question.additional_language_text[locale]}}</span>
                      <span v-if="question.required" class='red'>*<span class="sr-only">{{$t('required')}}</span></span></label>
                     
                      <select :id="`survey_responses[responses][${question.id}][survey_answer_id]`" 
                      :name="`survey_responses[responses][${question.id}][survey_answer_id]`" 
                      class="form-control" :class="{'is-invalid': errors[0]}" v-bind="field">
                        <option v-for="answer in question.answers" :value="answer.id" :key="answer.id">
                           {{ answer.answer_text }}
                        </option>
                     </select>                  
                      <div class="invalid-feedback" :id="`survey_responses[responses][${question.id}][survey_answer_id]_error`" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>  
                  </template>
                  <template v-else-if="questionIsTextEntry(question)">
                    <Field 
                      :name="`${locale == 'en' ? question.title : question.additional_language_text[locale]}`"                                                                                                                                                   
                      :rules="question.validation_type ?  {required: question.required, regex: [question.validation_type, `${locale == 'en' ? question.title.toLowerCase() : question.additional_language_text[locale].toLowerCase() }`]} : {required: question.required} "

                      v-slot="{ errors, field }"
                      v-model="responses[question.id].response_text">
                      <label :for="`survey_responses[responses][${question.id}][response_text]`">
                        <span >{{ locale == "en" ? question.title : question.additional_language_text[locale] }}</span>
                        <span v-if="question.required" class='red'>*<span class="sr-only">{{$t('required')}}</span></span>                  
                      </label>   
                      <input 
                        type="text" 
                        :id="`survey_responses[responses][${question.id}][response_text]`" 
                        :name="`survey_responses[responses][${question.id}][response_text]`" 
                        @input="formatField($event,question)" 
                        v-bind="field" 
                        class="form-control mt-2" 
                        :class="{'is-invalid': errors[0]}" />                     
                      <div class="invalid-feedback" :id="`survey_responses[responses][${question.id}][response_text]_error`" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>    
                    </Field>           
                  </template>
                  <template v-else-if="questionIsRichText(question)">
                      <froala-editor-vue 
                      :htmlfor="`survey_responses[responses][${question.id}][response_text]`"
                      :id="question.id" 
                      :isRequired="question.required"
                      @setText="setRichText"   
                      :title="`${locale == 'en' ? question.title : question.additional_language_text[locale]}`"   
                      :text="responses[question.id].response_text"/>                
                  </template>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import VueFroalaEditor from '../../../shared/FroalaEditor/FroalaEditor.vue';
import { Form, Field } from 'vee-validate'
import {getListArray, hasErrors} from '../../../shared/typescripts/error.ts'
export default {
  components: { VueFroalaEditor, Field, Form },
  props: [
    "s_questions",
    "s_reponses", 
    "locale"
],
  data() {
    return {
      questions: [],
      responses: {},
      errors: [],
    };
  },

  methods: {
    questionIsSelectOne: question => question.type === "select_one",
    questionIsSelectMultiple: question => question.type === "select_multiple",
    questionIsTextEntry: question => question.type === "text_entry",
    questionIsRichText: question => question.type === "rich_text",

    loadQuestionData() {
      this.questions = [];
      this.responses = {};
      let jsonObj = $.parseJSON(this.s_questions);
      let resp_JsonObj =
        resp_JsonObj !== [] ? this.s_reponses : this.responses;

      // Use the API data and initialize the questions we have to show
      jsonObj.forEach(item => {
        this.questions.push({
          position: item.position,
          id: item.id,
          survey_question_id: item.survey_question.id,
          title: item.survey_question.question_text,
          additional_language_text: item.survey_question.additional_language_text,
          type: item.survey_question.question_type,
          answers: item.survey_question.survey_answers,
          validation_type: item.survey_question.validation_type,
          required: item.survey_question.required
        });
      });
      // ... but create placeholder data so that all questions "have" responses, even if those responses are actually
      // just blank. That way the component doesnt need to care about partially-filled-out forms anywhere but here.
      this.questions.forEach(item => {
        if (!resp_JsonObj.hasOwnProperty(item)) {
          let result = resp_JsonObj.find(
            r => r.container_metadata_question_id === item.id
          );
          this.responses[item.id] = {
            id: typeof result === "undefined" ? null : result.id,
            container_metadata_question_id: item.id,
            survey_answer_id:
              typeof result === "undefined" ? null : result.survey_answer_id,
            response_text:
              typeof result === "undefined" ? null : result.response_text,
            validation_type: item.type === null ? null : item.type,
            required: item.required
          }
        }
        else {
          this.responses[item.id] = null
        }
      });
    },

    formatField(event, question) {
      if (!question.validation_type) {return event.target.value}
   
      if (question.validation_type == 'phone') {
        return this.phoneFormat(event)
      } else if (question.validation_type == 'postal_code') {
        return this.postalFormat(event)
      } else {
        return event.target.value
      }
      
    },

    phoneFormat(event) {
      let formattedInput = event.target.value.replace(/\D/g,'');
      var size = formattedInput.length;
      if (size>0) {formattedInput="("+formattedInput}
      if (size>3) {formattedInput=formattedInput.slice(0,4)+") "+formattedInput.slice(4,11)}
      if (size>6) {formattedInput=formattedInput.slice(0,9)+"-" +formattedInput.slice(9)}
      return event.target.value = formattedInput
        
    },

    postalFormat(event) {
      let formattedInput = event.target.value.toUpperCase().replace(/\W/g,'')
      if (formattedInput.length>3) {
        formattedInput=formattedInput.slice(0,3)+" "+formattedInput.slice(3,6)
      }
      event.target.value = formattedInput;
    },

    setRichText(obj) {
      this.responses[obj.id].response_text = obj.text
    },  
  },
  watch: {  
    responses(newVal){
      this.$emit('setResponses', newVal)
    }
  },
  mounted() {
    this.loadQuestionData();
  }
};
</script>
